// Captura e persistência de UTMs (last-touch) para envio junto aos forms SF.
// Port de site-edify-astro/src/scripts/utmTracking.js.
// localStorage sobrevive à navegação entre páginas até o submit do form.
const STORAGE_KEY = "edify_utms";
const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 dias

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureUtms() {
    try {
        const params = new URLSearchParams(window.location.search);
        const utms = {};
        let found = false;
        for (const key of UTM_KEYS) {
            const value = params.get(key);
            if (value) {
                utms[key] = value;
                found = true;
            }
        }
        // Sem UTM na URL mantém a última captura (last-touch só sobrescreve com UTM nova)
        if (!found) return;
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ utms, savedAt: Date.now() }));
    } catch {
        // localStorage indisponível (modo privado, cookies bloqueados) — segue sem UTM
    }
}

export function getStoredUtms() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const { utms, savedAt } = JSON.parse(raw);
        if (!savedAt || Date.now() - savedAt > TTL_MS) {
            localStorage.removeItem(STORAGE_KEY);
            return null;
        }
        return utms || null;
    } catch {
        return null;
    }
}
